<template>
	<div>
		<router-view></router-view>
		<c-menu ref="uploadMenu" :menu="uploadMenu" @handle="moreButtonHandle"></c-menu>
	</div>
</template>

<script>
	import Vue from 'vue'
	import {mapState} from 'vuex'
	
	export default {
		name: 'App',

		data() {
			return {
				onShowEvents: [],
				onShowOnceEvents: []
			}
		},

		computed: {
			...mapState(['ENV']),

			uploadMenu() {
				return [{
					name: '拍摄照片或视频',
					event: () => {
						this.takePhoto(this._uploadConfig);
					}
				}, {
					name: '从相册中选择',
					event: () => {
						this.uploadFile(this._uploadConfig, true);
					}
				}, {
					name: '从聊天会话中选择',
					event: () => {
						this.uploadFile(Object.assign({
							wechatFile: true
						}, this._uploadConfig, {
							type: 'all'
						}), true);
					}
				}];
			}
		},

		watch: {
			$route(val) {
				this.globalDialogDestroy();
				if (typeof val.meta.title == 'function') {
					this.setPageTitle(val.meta.title(val));
				} else if (val.meta.title) {
					this.setPageTitle(val.meta.title);
				}
			}
		},

		created() {
			this._$preview = this.$preview;
			Vue.prototype.$preview = data => {
				if (this.ENV == 'mp' && this.parseFile(data.src[data.index]).media == 'video') {
					this.mp.navigateTo('/pages/power', {
						power: 'previewVideo',
						data: encodeURIComponent(data.src[data.index])
					});
				} else {
					this._$preview(data);
				}
			};

			this.$store.dispatch('updateSystemConfig');

			if (/micromessenger/i.test(navigator.userAgent)) {
				if (window.__wxjs_environment == 'miniprogram') {
					this.$store.commit('setENV', 'mp');
				} else {
					this.$store.commit('setENV', /wxwork/i.test(navigator.userAgent) ? 'wxwork' : 'wechat');
					if (typeof WeixinJSBridge == 'object' && typeof WeixinJSBridge.invoke == 'function') {
						this.handleFontSize();
					} else {
						document.addEventListener('WeixinJSBridgeReady', this.handleFontSize, false);
					}
				}
			} else if (/DingTalk/i.test(navigator.userAgent)) {
				this.$store.commit('setENV', 'ding');
			} else {
				this.JSBridge('init', () => {
					this.$store.commit('setENV', 'app');
					Vue.prototype.$upload = async config => {
						let type = config.type.replace('mp4', 'video').split(',');
						if (type.includes('image') || type.includes('video')) {
							if (type.find(item => !['image', 'video'].includes(item))) {
								await this.$confirm({
									message: 'APP端暂时只支持上传图片和视频',
									cancelButton: false,
									buttonName: '继续上传'
								});
							}
							this.JSBridge('uploadFile', {
								type: type.filter(item => ['image', 'video'].includes(item)),
								multiple: config.multiple
							}, config.success);
						} else {
							this.$message({
								message: 'APP端暂时只支持上传图片和视频'
							});
						}
					}
				});
			}

			if (this.ENV == 'mp') {
				let query = this.query2Json();
				if (query.sa !== undefined) {
					localStorage.setItem('safeArea', query.sa || 0);
				}
				document.documentElement.style.setProperty('--safe-area', `${localStorage.getItem('safeArea') || 0}px`);
				document.documentElement.style.setProperty('--tabbar-bottom', parseInt(localStorage.getItem('safeArea')) ? `${localStorage.getItem('safeArea')}px` : '.2rem');
			} else {
				document.documentElement.style.setProperty('--safe-area', '0px');
				document.documentElement.style.setProperty('--tabbar-bottom', '.2rem');
			}

			if (['wechat', 'mp'].includes(this.ENV) && /iPhone/i.test(navigator.userAgent)) {
				this.WXReady();
			} else if (this.ENV == 'browser') {
				navigator.mediaDevices && navigator.mediaDevices.enumerateDevices().then(data => {
					this.$store.commit('setDeviceInfo', {
						cameraDevice: !!data.find(item => item.kind == 'videoinput')
					});
				});
			}
			
			window.addEventListener('hashchange', () => {
				if (window.location.hash) {
					let hash = window.location.hash.replace('#', '');
					this.onShowEvents.forEach(fun => {
						try {
							fun(hash);
						} catch(e) {}
					});
					this.onShowOnceEvents.forEach(fun => {
						try {
							fun(hash);
						} catch(e) {}
					});
					this.onShowOnceEvents = [];
					this.navigateBack();
				}
			});
		},

		methods: {
			onShow(fun, once) {
				once ? this.onShowOnceEvents.push(fun) : this.onShowEvents.push(fun);
			},

			offShow(fun) {
				let index = this.onShowEvents.findIndex(item => item == fun);
				if (index != -1) {
					this.onShowEvents.splice(index, 1);
				}
			},

			handleFontSize() {
				WeixinJSBridge.invoke('setFontSizeCallback', {'fontSize': 0});
				WeixinJSBridge.on('menu:setfont', ({fontSize}) => {
					WeixinJSBridge.invoke('setFontSizeCallback', {'fontSize': 0});
					if (window.innerWidth >= 425) {
						document.documentElement.style.fontSize = (Math.max(0, (fontSize - 2) * 6) / 100 + 1) * 56.6665 + 'px';
					} else {
						document.documentElement.style.fontSize = (Math.max(0, (fontSize - 2) * 6) / 100 + 1) * 13.3333 + 'vw';
					}
				});
			},
			
			query2Json() {
				let result = {}, searchStr = location.search.replace(/^\?/, '');
				if (!searchStr) return result;
				searchStr.split('&').forEach(item => {
					let [key, value = ''] = item.split('=');
					if (key) {
						result[decodeURIComponent(key)] = decodeURIComponent(value);
					}
				});
				return result;
			},

			uploadFileHandle(config) {
				this._uploadConfig = config;
				this.$refs.uploadMenu.open();
			}
		}
	}
</script>

<style lang="stylus">
	@import './assets/style/reset';
	@import './assets/style/fonts';
		
	html {
		background: #F2F2F2;
		user-select: none;
		overscroll-behavior: none;
	}

	body {
		-webkit-text-size-adjust: 100% !important;
		text-size-adjust: 100% !important;
		-moz-text-size-adjust: 100% !important;
	}

	// 临时样式
	.c-datetime-main {
		font-size: .28rem;
	}
	// end 临时样式
	
	.c-input,
	.c-select,
	.c-datetime {
		box-shadow: inset 0 2px 4px #eee;
	}

	.c-radio {
		display: flex !important;
		align-self: center;
		justify-content: center;
		box-sizing: border-box;
		min-width: 2rem;
		height: auto !important;
		border-radius: .36rem;
		padding: 0 .32rem;
		background: #F5F5F5;

		&.z-chk {
			color: #fff !important;
			background: var(--color-main);

			&:after {
				content: '\e65e';
				margin-left: .12rem;
				line-height: .72rem;
				font-family: 'iconfont';
				font-size: .3rem;
			}
		}

		&.z-dis {
			background: #F5F5F5;

			&:after {
				color: #bbb;
			}
		}

		&-group {
			display: flex !important;
			flex-wrap: wrap;
		}

		&-check {
			display: none !important;
		}

		&-content {
			margin: 0 !important;
			line-height: .72rem !important;

			^[-1].z-chk ^[-2..-1] {
				font-weight: normal !important;
			}

			^[-1].z-dis ^[-2..-1] {
				color: #aaa;
			}
		}
	}

	.c-form {
		padding: .32rem;
		background: #fff;
		
		&-item-unit .reason-option {
			margin: 0 -.32rem;
		}
	}

	.c-dialog {
		&[position=bottom] {
			.c-dialog-head {
				border-radius: .2rem .2rem 0 0;
				color: #fff;
				background: var(--color-main);
			}

			.c-dialog-handle-item {
				border-radius: 100%;
				font-size: .26rem !important;
				color: #fff !important;
				background: rgba(0,0,0,.2);
			}
		}

		&:not([position=center]) {
			.c-dialog-button {
				padding-bottom: var(--safe-area) !important;
			}
		}
	}
	.selector-search {
		box-sizing: border-box;
		height: .72rem;
		border: .02rem solid var(--unit-border);
		border-radius: .36rem;
		padding: 0 .3rem;
		background: #fff;

		&-bar {
			border-bottom: .01rem solid #eee;
			padding: 0 .32rem .24rem;
			background: var(--color-main);
		}

		&-icon {
			margin-right: .2rem;
			font-size: .32rem;
			color: #bbb;
		}

		input {
			height: 100%;
		}
	}


	.c-select-picker-search-bar {
		background: var(--color-main);
	}

	.c-tab-list ul[type=card] {
		gap: .12rem;
		justify-content: flex-start;
		width: 100%;
		padding: .2rem 0;

		li {
			height: .6rem;
			border-radius: .3rem;
			padding: 0 .24rem;
			font-size: .28rem;
			white-space: nowrap;
			background: #F5F5F5;

			&.z-crt {
				color: #00A1E9;
				background: #F0F9FE;
			}
		}
	}

	.c-file-media {
		&.s-video {
			position: relative;

			&:after {
				content: '';
				position: absolute;
				inset: 0;
				background-image: url('https://ylserver-2025-online.oss-cn-shanghai.aliyuncs.com/app_static/player.png');
				background-size: 50% 50%;
				background-position: center center;
				background-repeat: no-repeat;
			}
		}
	}
</style>